import { render, staticRenderFns } from "./MMP_ReleaseNotes.vue?vue&type=template&id=a99e1372&"
import script from "./MMP_ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./MMP_ReleaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./MMP_ReleaseNotes.vue?vue&type=style&index=0&id=a99e1372&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports